define(
    'LNRS/Components/Charts/donut',["jquery", "d3", "scrollMagic", "mustache", "LNRS/Components/Charts/Base"],
    function ($, d3, ScrollMagic, mustache, Base) {
        "use strict";

        function DonutChart(scope, chartInfo, id) {
            Base.call(this, scope, chartInfo, id);
        }

        DonutChart.prototype = Object.create(Base.prototype);

        DonutChart.prototype.initChart = function initChart(gDiv, dataset) {
            var locals = {};

            var svgWidth = $(gDiv).width();
            var svgHeight = svgWidth;
            $(gDiv).css('padding-bottom','105%');
            $(gDiv).css('height','1px');

            if (svgWidth > 500 ) {
                $(gDiv).css('padding-bottom','570px');
                svgHeight = 570;
            }
            
            var svg = d3.select(gDiv)
                .append('svg')
                .attr('viewBox', '0,0,'+ svgWidth + ','+ svgHeight );

            // shadow for tooltip
            var chartDefs = svg.append('defs');
            var chartFilter = chartDefs.append('filter')
                .attr('id','shadow')
                .attr('x','0')
                .attr('y','0');
            chartFilter.append('feOffset')
                .attr('result','offOut')
                .attr('in','SourceAlpha')
                .attr('dx','-5')
                .attr('dy','-5');
            chartFilter.append('feGaussianBlur')
                .attr('result','blurOut')
                .attr('in','offOut')
                .attr('stdDeviation','6');
            chartFilter.append('feBlend')
                .attr('in','SourceGraphic')
                .attr('in2','blurOut')
                .attr('mode','normal');            
        }

        DonutChart.prototype.animateChart = function animateChart(gDiv, dataset) {
            var svg = d3.select(gDiv + " svg"),
            
                format = d3.format(".0%"),
                fontSize = 36,
                duration = 1500,
                transition = 200,
                svgWidth = $(gDiv).width(),
                svgHeight = svgWidth;
                if (svgWidth > 500 ) {
                    svgHeight = 570;
                }
                
                
            if (svgWidth < 400) {
                var    margin = { top: 10, right: 10, bottom: 10, left: 10 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    fontSize = 32,
                    radius = chartWidth/2;
            } else if (svgWidth > 500) {
                var margin = { top: 20, right: 20, bottom: 20, left: 20 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    radius = 250;
            } else {
                var margin = { top: 20, right: 20, bottom: 20, left: 20 },
                    chartWidth  = svgWidth  - margin.left - margin.right,
                    chartHeight = svgHeight - margin.top  - margin.bottom,
                    radius = chartWidth/2;
            };
                
            var chartWrapper = svg.append('g')
                .style('font-family',"'Source Sans Pro'")
                .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'),
                
                p0 = chartWrapper.append('g')
                    .attr('id', 'donut1')
                    .attr('transform','translate(' + chartWidth/2 + "," + (radius + 10) + ')'),
                    
                pie2 = d3.pie().sort(null),
                
                // background donut
                arcUnder = d3.arc()
                    .innerRadius(radius - 25)
                    .outerRadius(radius - 5);
                var pie1 = d3.pie()
                    .value(function(d) { return d.value; })
                    .sort(null);

                //
                p0.selectAll('.bg')
                    .data(pie1([{
                        value: 1
                      }]))
                    .enter().append("path")
                    .attr("class", "bg")
                    .attr("fill", "#e4e5e4")
                    .attr("d", arcUnder);
                    
                

            dataset.lower = [0,100];
            dataset.upper = [dataset.points, 100-dataset.points];
            var arcM = d3.arc()
                .innerRadius(radius -30)
                .outerRadius(radius);
                
            var movable = p0.append("g")
                .attr("class", "movable");
            var path = movable.selectAll("path")
                            .data(pie2(dataset.lower))
                            .enter().append("path")
                            .attr("class", function (d, i) {
                                return "color" + i;
                            })
                            .attr("fill", dataset.colors[dataset.colorIndex])
                            .attr("d", arcM)
                            .each(function (d) {
                                this._current = d;
                            });

            var text = movable.append("text")
                    .attr("text-anchor", "middle")
                    .attr("font-size", fontSize)
                    .attr("fill",dataset.colors[dataset.colorIndex])
                    .attr("dy", ".3em");
                    
            d3.select(gDiv + " .color1")        
                .attr("fill","none");
                var progress = 0;    
                var timeout = setTimeout(function () {
                    clearTimeout(timeout);
                    path = path.data(pie2(dataset.upper));
                    path.transition().duration(duration).attrTween("d", function (a) {
                        var i = d3.interpolate(this._current, a);
                        var i2 = d3.interpolate(progress, dataset.points);
                        this._current = i(0);
                        return function (t) {
                            
                            text.text(format(i2(t) / 100));
                            return arcM(i(t));
                        };
                    });
                }, 1500*dataset.delayIndex);
        }

        return function initDonutChart(args) {
            return args.IsExperienceEditorEditing ? null : new DonutChart(
                args.scope,
                args.chartInfo,
                args.id);
        };
    });
